<script setup>
  import { onMounted, ref } from 'vue';
  import Chevron from 'common/icons/Chevron.svg';

  const icon = Chevron;

  const showLeftArrow = ref(false);
  const showRightArrow = ref(false);
  const startObserver = ref();
  const endObserver = ref();
  const scroller = ref(null);
  const scrollerItems = ref(null);
  const start = ref(null);
  const end = ref(null);

  const scroll = movement => {
    // https://stackoverflow.com/questions/61941291/scrollleft-animation-clean-vanilla-js
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
    if (!scrollerItems.value || !scroller.value) {
      return;
    }
    if (scrollerItems.value.children && scrollerItems.value.children[1]) {
      scroller.value.scroll({
        left:
          scroller.value.scrollLeft +
          (scrollerItems.value.children[1].offsetWidth + 16) * movement,
        behavior: 'smooth',
      });
    }
  };

  onMounted(() => {
    if (!scrollerItems.value) {
      return;
    }
    const screenWidth = window.innerWidth;
    const childWidth = scrollerItems.value.children[1].offsetWidth + 16;
    const elementsWidth = scrollerItems.value.children.length * childWidth;
    if (elementsWidth < screenWidth) {
      showLeftArrow.value = false;
      showRightArrow.value = false;
    }

    const intersectionOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.2,
    };

    const handleIntersection = (activate, deactivate) => {
      return async ev => (ev[0].isIntersecting ? deactivate() : activate());
    };
    startObserver.value = new IntersectionObserver(
      handleIntersection(
        () => {
          showLeftArrow.value = true;
        },
        () => {
          showLeftArrow.value = false;
        },
      ),
      intersectionOptions,
    );
    startObserver.value.observe(start.value);
    endObserver.value = new IntersectionObserver(
      handleIntersection(
        () => {
          showRightArrow.value = true;
        },
        () => {
          showRightArrow.value = false;
        },
      ),
      intersectionOptions,
    );
    endObserver.value.observe(end.value);
  });
</script>

<template>
  <div class="scroller-container">
    <div class="relative">
      <div ref="scroller" class="scroller">
        <div ref="scrollerItems" class="scrollerItems scroller-nobars">
          <div ref="start" class="relative marker">s</div>
          <slot></slot>
          <div ref="end" class="relative marker">e</div>
        </div>
      </div>
    </div>

    <div class="buttons">
      <div v-if="showRightArrow" @click="scroll(1)" class="arrow-cont right">
        <span class="icon right" v-html="icon" aria-hidden="true"></span>
      </div>
      <div v-if="showLeftArrow" @click="scroll(-1)" class="arrow-cont left">
        <span class="icon left" v-html="icon" aria-hidden="true"></span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .scroller-container {
    width: 100%;
    position: relative;
  }

  .scroller-nobars {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .scroller {
    width: 100%;
    overflow-x: scroll;
    position: relative;
    z-index: 1;

    /* Estilos para ocultar la barra de desplazamiento */
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  .scroller::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }

  .scrollerItems {
    display: flex;
    width: 100%;
    height: 100%;
  }

  .marker {
    opacity: 0;
  }

  .buttons {
    z-index: 2;
    height: fit-content;
    position: absolute;
    width: 100%;
    top: 0;
    right: 0;
  }

  .arrow-cont {
    width: 38px;
    height: 38px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    border: solid 1px $GRAY;
    background-color: $WHITE;
    position: absolute;
    top: -9px;

    &.right {
      right: 0;
    }

    &.left {
      left: 0;
    }
  }

  .icon {
    height: 18px;
    width: 18px;
    display: block;

    &.left {
      transform: rotate(90deg);
    }

    &.right {
      transform: rotate(-90deg);
    }
  }
</style>
